import React, { useState, useCallback, useContext } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Checkbox } from '@getgrover/ui';
import { ThemeContext } from 'styled-components';

import Translator from 'ggApp/modules/translator/components/Translator';
import { user as userSelector } from 'ggApp/modules/auth/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { PaymentSdkContext } from 'ggApp/shared/common/Payment/PaymentGatewayList/state/paymentSdkContext';

import {
    Wrap,
    FintecIcon,
    Header,
    SubHeader,
    TermsWrap,
    TermsText,
    ButtonWrap,
    BackButton,
    SubmitButton,
} from './styles';

const mapStateToProps = createStructuredSelector({
    user: userSelector,
    activeStore: activeStoreSelector,
});

const SepaPaymentTerms = ({
    onPaymentMethodCreated,
    paymentTermsInfo: gateway,
    setPaymentTermsInfo,
    user,
    activeStore,
}) => {
    const sdkInstance = useContext(PaymentSdkContext);
    const theme = useContext(ThemeContext);

    const [isChecked, setIsChecked] = useState(false);
    const [isFormSubmitting, setFormSubmittingState] = useState(false);

    const handleSubmit = useCallback(
        (event) => {
            setFormSubmittingState(true);

            sdkInstance
                .createPaymentMethod(gateway, user.id)
                .then(({ checkoutUrl }) => {
                    onPaymentMethodCreated({
                        redirect: {
                            url: checkoutUrl,
                            gatewayType: gateway.type,
                        },
                    });
                })
                .catch(() => {
                    setPaymentTermsInfo(null);
                    setFormSubmittingState(false);
                });

            event.preventDefault();
        },
        [sdkInstance, gateway, user.id, onPaymentMethodCreated, setPaymentTermsInfo],
    );

    return (
        <Wrap>
            <FintecIcon width="134px" light={theme.mode === 'dark'} />
            <Header>
                <Translator tk="PAYMENT_REDIRECT_SEPA_HEADER" />
            </Header>
            <SubHeader>
                <Translator tk="PAYMENT_REDIRECT_SEPA_SUBHEADER" />
            </SubHeader>
            <TermsWrap>
                <Checkbox
                    accentColor={theme.colors.Foreground}
                    onChange={() => setIsChecked(!isChecked)}
                />
                <TermsText>
                    <Translator
                        tk="PAYMENT_REDIRECT_SEPA_TERMS_TEXT"
                        withValues={{
                            storeCode: activeStore.code,
                        }}
                    />
                </TermsText>
            </TermsWrap>
            <ButtonWrap>
                <BackButton outlined onClick={() => setPaymentTermsInfo(null)}>
                    <Translator tk="NEW_CHECKOUT_HOME_BACK_BTN" />
                </BackButton>
                <SubmitButton
                    isDisabled={!isChecked || isFormSubmitting}
                    fullWidth
                    onClick={handleSubmit}
                >
                    <Translator tk="NEW_CHECKOUT_HOME_CONTINUE_BTN" />
                </SubmitButton>
            </ButtonWrap>
        </Wrap>
    );
};

export default connect(mapStateToProps)(SepaPaymentTerms);
